import React from 'react';
import './index.css';

export const Details = ({ items, pullRight }) => {
	if (!items?.length) return null;

	return (
		<div className="ctrl-details">
			{pullRight && <div className="flex-grow"></div>}
			{items.map((item, i) => {
				return (
					<div key={`details-${i}`}>
						<div className={item.titleNoWrap ? 'nowrap' : undefined}>{item.title || '-'}</div>
						<div className={item.contentNoWrap ? 'nowrap' : undefined}>
							{typeof item.value === 'function' ? item.value() : item.value}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Details;
